import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundOutpaint from '../pages/PagePlaygroundOutpaint'

type PlaygroundRunSearch = {
  runId?: string
}

export const Route = createFileRoute('/playground/outpaint')({
  component: PagePlaygroundOutpaint,
  validateSearch: (search: Record<string, unknown>): PlaygroundRunSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined
  })
})
